/* 0 15px
 * Copyright (c) 2021 Adres.
 * All rights reserved.
 */

const styles = theme => ({
  notificationHolder: {
    padding: '0 15px',
    width: '100%',
  },
  terminateBtnContainer: {
    padding: '0 24px',
    marginTop: '32px',
  },
  terminateBtn: {
    width: '100%',
    color: theme.palette.primary.adgmBlack,
    background: theme.palette.primary.white,
    fontWeight: '600',
    fontSize: '16px',
    textTransform: 'capitalize',
    lineHeight: '24px',
    padding: '18px 16px',
    border: `1px solid ${theme.palette.primary.adgmBlack}`,

    '& > .MuiButton-label': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      '& img': {
        marginRight: '8px',
      },
    },
  },
  TerminateBtn: {
    fontSize: '16px',
    color: '#342D3D',
    height: '48px',
    minWidth: '151px',
    border: '1px solid #342D3D',
    textTransform: 'none',
    marginRight: '16px',
    borderRadius: '0px',
    transition: 'none',
    '&:hover': {
      background: '#342D3D',
      color: '#fff',
    },
  },
  innerModalAccept: {
    position: 'relative',
    '& $crossIconimg': {
      position: 'absolute',
      right: '0',
      top: '0',
    },
    '& h1': {
      marginBottom: '24px',
      fontSize: '20px',
    },
    '& h2': {
      marginBottom: '28px',
      fontWeight: '400',
      fontSize: '16px',
    },
  },
  crossIconimg: {
    cursor: 'pointer',
  },
  rejectApplicationbtn: {
    transition: 'none',
    textTransform: 'none',
    color: '#DF2C2C',
    fontSize: '14px',
    '& svg': {
      marginRight: '8px',
      fontSize: '18px',
    },
    '&:hover': {
      background: 'transparent',
    },
    '& img': {
      marginRight: '8px',
      width: '18px',
    },
  },
  cancelBtn: {
    padding: '0 15px',
  },
  errorMessage: {
    marginBottom: '10px',
  },
  main: {
    padding: '20px 0',
  },
  container: {
    maxWidth: '1184px',
  },
  paperCardFrame: {
    marginBottom: '24px',
    border: 'none !important',
  },
  innerCardGrid: {
    padding: '24px',
    border: '1px solid #CED1D6',
  },
  paymentMethodContent: {
    padding: '20px 10px',
    '& $radioHelperText': {
      paddingLeft: '0',
    },
    '& $textADGMGray': {
      flex: '1',
      textAlign: 'right',
    },
  },
  certificatesInnerCardGrid: {
    padding: '0',
    '& $paymentDiscription': {
      '& span': {
        color: '#000000',
      },
    },
    '& $paymentDiscriptionContainer': {
      padding: '16px 20px !important',
      borderBottom: '1px solid #EBEEF3',
    },
    '& $paymentDiscriptionStrong': {
      '& span': {
        fontWeight: '700 !important',
      },
    },
    '& $paymentDiscriptionTotalAmount': {
      marginBottom: '0',
      '& span': {
        color: '#D2374F !important',
      },
    },
    '& $payNowBtnContainer': {
      padding: '20px 24px',
    },
  },
  titleHead: {
    background: 'transparent',
    color: '#342D3D',
    display: 'flex',
    alignItems: 'flex-end',
    padding: '16px 0px',
    borderBottom: '1px solid #CED1D6',
    borderRadius: '0px',
    '& h1': {
      marginBottom: '0',
      marginRight: '8px',
      '& span': {
        color: '#D2374F',
      },
    },
  },
  // Title: {
  //   color: '#342D3D',
  // },
  initiateservicedtaile: {
    display: 'grid',
    gridTemplateColumns: '61px auto',
    gap: '9px',
    marginBottom: '30px',
    '& h2': {
      fontSize: '18px',
      fontWeight: '600',
    },
  },
  previewbtnHolder: {
    paddingTop: '30px',
  },
  preciewcontractBtn: {
    border: '1.36111px solid #342D3D',
    borderRadius: '0px',
    fontWeight: '600',
    fontSize: '16px',
    minWidth: '230px',
    height: '60px',
    '& img': {
      marginRight: '8px',
      width: '20px',
    },
  },
  btncardHolder: {
    marginBottom: '30px',
  },
  mastercardbtn: {
    border: '1px solid #342D3D',
    borderRadius: '0px',
    fontWeight: '500',
    fontSize: '14px',
    minWidth: '196px',
    height: '52px',
    marginRight: '12px',
    '& img': {
      marginRight: '7px',
    },
  },
  adgmwalletBtn: {
    borderRadius: '0px',
    fontWeight: '500',
    fontSize: '12px',
    minWidth: '196px',
    height: '52px',
    color: '#342D3D',
    background: '#fff',
    marginRight: '12px',
    boxShadow: '0px 1px 6px rgba(0, 0, 0, 0.2)',
    marginBottom: '7px',
    '& img': {
      marginRight: '7px',
    },
    '& p': {
      margin: '0',
      '& span': {
        display: 'block',
        fontSize: '12px',
        color: '#8C9099',
      },
    },
  },
  activetBtn: { border: '1px solid #342D3D' },
  warningmassage: {
    background: '#EBF7FF',
    border: '1px solid #0496FF',
    borderRadius: '0px',
    display: 'inline-flex',
    alignItems: 'center',
    padding: '12px',
    marginBottom: '20px',
    '& p': {
      fontSize: '12px',
    },
    '& img': {
      marginRight: '8px',
    },
  },
  detailItem: {
    borderBottom: '1.46951px solid #EBEEF3',
    padding: '20px 0',
    color: '#565960',
    display: 'flex',
    alignItems: 'center',
    '&:first-child': {
      paddingTop: '0',
    },
    '&:last-child': {
      borderBottom: '0',
      paddingBottom: '0',
    },
    '& h2': {
      fontWeight: '600',
      color: '#342D3D',
      fontSize: '18px',
    },
  },
  darkgray: {
    color: '#fff',
    background: '#565960',
  },
  uniChip: {
    fontWeight: '500',
    fontSizeL: '16px',
    padding: '8px 16px',
    marginLeft: 'auto',
  },
  walletbalanceDetail: {
    padding: '20px 0',
    color: '#8C9099',
    borderTop: '1px solid #EBEEF3',
    borderBottom: '1px solid #EBEEF3',
    marginBottom: '20px',
    '& h6': {
      fontWeight: '500',
      color: '#342D3D',
      fontSize: '12px',
    },
    '& p': {
      fontSize: '12px',
    },
  },
  fieldsetradio: {
    display: 'flex',
  },
  usercheckedradio: {
    padding: '20px 0',
    color: '#190B28',
    flexWrap: 'nowrap',
    alignItems: 'center',
    flexDirection: 'row',
    '& + $usercheckedradio': {
      borderTop: '1px solid #EBEEF3',
    },
    '& input:checked + div': {
      color: '#000',
    },
    '& svg': {
      height: '28px',
      width: '28px',
    },
    '&:first-child': {
      paddingTop: '0',
    },
  },
  usercheckedradioColumn: {
    alignItems: 'start',
    '& > span': {
      paddingTop: '0',
    },
  },
  radioHelperText: {
    fontSize: '18px',
    color: '#342D3D',
    fontWeight: '500',
    paddingLeft: '10px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexGrow: '1',
    '& img': {
      width: '22px',
    },
  },
  radioHelperTextColumn: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center',
    '& span:last-child': {
      marginTop: '10px',
      '& span:not(:first-of-type)': {
        marginRight: '5px',
      },
    },
  },
  textADGMGray: {
    color: '#8C9099',
    fontWeight: '400',
  },
  Addnewcard: {
    fontWeight: '500',
    color: '#1C999B',
  },
  paymentDiscription: {
    display: 'flex',
    alignItems: 'center',
    color: '#565960',
    marginBottom: '12px',
    '& span:first-child': {
      maxWidth: '65%',
    },
    '& $textright': {
      marginLeft: 'auto',
      color: '#342D3D',
      fontWeight: '500',
      flexShrink: 0,
    },
    '&$headingbig': {
      borderBottom: '1px solid #EBEEF3',
      color: '#000',
      fontSize: '14px',
      fontWeight: '500',
      paddingBottom: '25px',
      paddingTop: '15px',
      '&:first-child': {
        paddingTop: '0px',
      },
    },
    '&$headingbig_nonborder': {
      color: '#000',
      fontSize: '20px',
      fontWeight: '500',
    },
    '&$vatCharges': {
      padding: '16px 0',
      borderTop: '1px solid #EBEEF3',
    },
    '&$totalpayment': {
      padding: '16px 0',
      borderTop: '1px solid #EBEEF3',
      color: '#0D2A3A',
      fontWeight: '600',
      '& $textright': {
        color: '#0D2A3A',
        fontWeight: '600',
      },
    },
  },
  paymentDiscriptionContainer: {},
  paymentDiscriptionStrong: {},
  paymentDiscriptionTotalAmount: {},
  payNowBtnContainer: {},
  headingbig: {},
  textright: {},
  vatCharges: {},
  totalpayment: {},
  headingbig_nonborder: {},
  PaynowBtn: {
    display: 'block',
    height: '60px',
    background: '#0088FF',
    color: '#fff',
    borderRadius: '0px',
    fontWeight: '600',
    fontSize: '16px',
    width: '100%',
    textTransform: 'none',
    '&:hover': {
      background: '#0088FF',
    },
    // margin: '16px',
    // marginBottom: '50px',
  },
  breadcrumbsHolder: {
    padding: '0 0 30px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    '& $serviceid': {
      marginLeft: 'auto',
    },
  },
  appId: {
    marginBottom: '20px',
    color: '#8c9099',
    '&>h2': {
      fontSize: '14px',
      fontWeight: '600',
    },
    '& > h2 > span': {
      fontSize: '14px',
      fontWeight: '400',
    },
  },
  serviceid: {},
  breadcrumbs: {
    fontSize: '12px',
    '& li': {
      padding: '0',
      border: '0',
    },
    '& a': {
      color: '#1C999B',
      textDecoration: 'none',
      '& svg': {
        fontSize: '18px',
      },
    },
    '& $activelink': {
      color: '#8C9099',
    },
  },
  activelink: {},
  mobileTitlehead: {
    borderBottom: '3px solid #EBEEF3',
    position: 'relative',
    // marginBottom: '12px',
    '& > div': {
      padding: '0 15px 10px',
    },
    '& a': {
      color: '#342D3D',
      padding: '7px 0',
      fontWeight: '500',
      display: 'block',
      textDecoration: 'none',
      '&:hover': {
        textDecoration: 'none',
      },
      '& img': {
        marginRight: '13px',
      },
    },
    '& $grayArea': {
      background: '#F8F8F8',
      color: '#8C9099',
      '& p': {
        fontSize: '12px',
      },
    },
  },
  topTerminateBar: {
    display: 'flex',
  },
  topTerminateBar_text: {
    paddingLeft: '15px',
  },
  rejectedTooltip: {
    background: '#FFFAEB',
    color: '#342D3D',
    borderRadius: '0px',
    border: '1px solid #FFAB2D',
    fontSize: '14px',
    fontWeight: '500',
    display: 'inline-flex',
    alignItems: 'center',
    // justifyContent: 'center',
    height: '45px',
    width: '100%',
    padding: '5px 12px',
    marginBottom: '16px',
    '& img': {
      marginRight: '8px',
    },
  },
  grayArea: {},
  '@media (max-width: 768px)': {
    notificationHolder: {
      padding: '0 15px',
    },
    container: {
      padding: '0',
    },
  },

  // payment card
  card_container: {
    '& > div': {
      padding: '28px 0px !important',
      margin: '0px 24px',
      borderBottom: '1px solid #EBEEF3',
    },
    '& > div:last-child': {
      borderBottom: 'none',
    },
  },
  card_list: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    '& > div:first-child': {
      display: 'flex',
      alignItems: 'center',
      '& > img': {
        marginRight: '12px',
      },
      '& > div > p:last-child': {
        color: theme.palette.primary.dim,
        fontSize: '14px',
      },
      '& > div > p:first-child': {
        color: theme.palette.secondary.main,
        fontSize: '14px',
      },
    },
    '& > div:last-child': {
      '& > button': {
        background: 'none',
        fontSize: '14px',
      },
    },
  },

  cardItem_right: {
    color: '#8C9099',
    fontSize: '12px',
  },
  cardItem_rightText: {
    marginRight: '5px',
  },

  '@media (min-width: 992px)': {
    contentArea: {
      paddingLeft: '50px',
    },
  },
  adgmGold: {
    color: theme.palette.primary.main,
  },
  infoMessageTooltip: {
    background: '#EBF7FF',
    color: '#342D3D',
    borderRadius: '0px',
    border: '1px solid #0496FF',
    fontSize: '12px',
    lineHeight: '1.4',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '44px',
    padding: '12px',
    marginBottom: '0',
    '& img': {
      marginRight: '8px',
    },
  },
  trashIcon: {
    '& img': {
      position: 'absolute',
      right: 15,
      top: 0,
    },
  },
  '@media (max-width: 960px)': {
    // mdDown
    titleHead: {
      borderBottom: '0px',
      padding: '16px',
      borderRadius: '',
      '& h1, h2': {
        color: '#342D3D',
        fontWeight: '600',
        fontSize: '16px',
      },
    },

    detailItem: {
      borderBottom: '0',
      paddingTop: '8px',
      paddingBottom: '8px',
      '&:first-child': {},
      '&:last-child': {
        borderBottom: '0',
        paddingBottom: '0',
      },
      '& h2': {
        fontWeight: '500',
        color: '#342D3D',
        fontSize: '12px',
      },
    },
    paperCardFrame: {
      marginBottom: '0px',
      borderRadius: '0px',
      border: '0px',
    },
    innerCardGrid: {
      fontSize: '14px',
      padding: '8px 16px',
    },
    checkoutBtnWrapper: {
      display: 'flex',
      justifyContent: 'center',
      margin: '16px',
    },
    checkoutBtn: {
      display: 'flex',
      background: theme.palette.primary.main,
      color: '#fff',
      borderRadius: '0px',
      fontWeight: '600',
      fontSize: '16px',
      // width: '100%',
      width: '328px',
      height: '48px',
      textTransform: 'none',
      '&:hover': {
        background: '#bf2b42',
      },
      // margin: '16px',
      marginBottom: '50px',
    },
    radioHelperText: {
      fontSize: '14px',
      paddingLeft: '0',
      '& img': {
        width: '19px',
      },
      '& $textADGMGray': {
        fontSize: '12px',
      },
    },
    gridContainer: {
      marginBottom: '40px',
    },
    fixedbtnHolder: {
      position: 'fixed',
      bottom: '0',
      left: '0',
      right: '0',
      background: '#fff',
      padding: '16px',
      borderTop: '3px solid #EBEEF3',
      zIndex: '9999',
      '& button': {
        width: '100%',
        borderRadius: '0px',
        padding: '0.65em 3em',
        height: '48px',
      },
    },
    topTerminateBar_main: {
      padding: '0.65em 2em',
    },
  },
  modalAccptBtn: {
    background: theme.palette.primary.main,
    fontSize: '16px',
    color: '#fff',
    height: '48px',
    minWidth: '151px',
    textTransform: 'none',
    borderRadius: '0px',
    '&:hover': {
      background: '#c02b42',
    },
  },
  Title: {
    fontWeight: '600',
    fontSize: '16px',
  },
  paymentHead: {
    fontWeight: '600',
    lineHeight: '24px',
  },
  paymentDetails: {
    fontSize: '14px',
    lineHeight: '21px',
    '& span': {
      maxWidth: '60%',
    },
  },
  [theme.breakpoints.down('sm')]: {
    paymentHead: {
      fontSize: '14px',
      lineHeight: '21px',
    },
    innerModalAccept: {
      '& $crossIconimg': {
        right: '-4px',
      },
      '& h1': {
        marginBottom: '20px',
        fontSize: '16px',
      },
      '& h2': {
        marginBottom: '18px',
        fontSize: '14px',
      },
      '& hr': {
        backgroundColor: '#CED1D6',
      },
    },
    TerminateBtn: {
      fontSize: '14px',
      minWidth: '100px',
      marginRight: '16px',
    },
    modalAccptBtn: {
      fontSize: '14px',
      minWidth: '100px',
    },
  },
});

export default styles;
